// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__lfKh2","colMin":"styles_colMin__22jRd","colCheckbox":"styles_colCheckbox__xbOOD"};